const React = require('react');
const PersonAddIcon = require('@material-ui/icons/PersonAdd').default;
const CircularProgress = require('@material-ui/core/CircularProgress').default;
const Tooltip = require('../Tooltip/A');
const Ripple = require('../Ripple');
const {useState} = require('react');
const {apiAdminAccountsSubmerchantCreate, apiAdminAccountsSubmerchantUpdate} = require('../../../api/admin/accounts');
const {DisplayIdAdmin} = require('../../dumb/DisplayData');
const {default: RefreshIcon} = require("@material-ui/icons/Refresh");

module.exports = ({id, submerchantId, update}) => {
  const [isPending, setIsPending] = useState(false);
  const handleClickCtor = (fn) => () => {
    setIsPending(true);
    fn().then(update).finally(() => {
      setIsPending(false);
    });
  };

  if (isPending) return <CircularProgress className="cCT*2"/>;

  if (submerchantId) {
    return (
      <div className="layoutRow jcSB aiC">
        <DisplayIdAdmin>{submerchantId}</DisplayIdAdmin>
        <Tooltip title="Update ID" disabledCopy>
          <Ripple className="bgNone p0 b0 layoutRow fvaC fhaE"
                  disabled={isPending}
                  onClick={handleClickCtor(() => apiAdminAccountsSubmerchantUpdate(id))}
          >
            <RefreshIcon className="w25 h25" />
          </Ripple>
        </Tooltip>
      </div>
    )
  }
  return (
    <Tooltip title="Register BPay Submerchant" disabledCopy>
      <Ripple className="bgNone p0 b0 layoutRow fvaC fhaE"
        disabled={isPending}
        onClick={handleClickCtor(() => apiAdminAccountsSubmerchantCreate(id))}
      >
        <PersonAddIcon className="w25 h25"/>
      </Ripple>
    </Tooltip>
  );
};
